import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Logo from "../Logo";
import { PLAY_STORE_URL } from "@/data/aboutContent";

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/programs", label: "Discover" },
  { to: "/scholars", label: "Scholars Program" },
  { to: "/contact", label: "Contact" },
  { to: "/partners/login", label: "Become our Partner" },
];

const MarketingNav = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <motion.nav
      className="sticky top-0 z-[100] bg-skutopia-950/95 backdrop-blur-md text-white border-b border-white/10 w-full overflow-visible"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", stiffness: 100, damping: 20 }}
    >
      <div className="w-full px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-visible">
        <div className="flex items-center justify-between py-3.5">
          <Link to="/" className="flex items-center">
            <Logo withText />
          </Link>

          <div className="hidden lg:flex items-center gap-7 overflow-visible flex-1 justify-center">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm font-medium text-white/75 hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-2 text-sm font-semibold text-skutopia-900 hover:bg-skutopia-50 transition-colors"
          >
            Get the app <ArrowRight className="h-3.5 w-3.5" />
          </a>

          <button
            type="button"
            className="flex lg:hidden items-center justify-center p-2 rounded-md text-white hover:bg-white/10"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Open menu"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>
      </div>

      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            className="lg:hidden bg-skutopia-900 border-t border-white/10"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
          >
            <div className="px-4 py-4 space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileMenuOpen(false)}
                  className="block px-3 py-2.5 text-base font-medium"
                >
                  {link.label}
                </Link>
              ))}
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 flex items-center justify-center gap-1.5 rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-skutopia-900"
              >
                Get the app <ArrowRight className="h-3.5 w-3.5" />
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default MarketingNav;
